import { icons } from 'src/assets/iconDef/icon.def';

export const discoveryMenuDef = [
    {
        name: 'menu.discovery_application',
        resource: 'discovery_application',
        icon: 'fa fa-plus-square',
        url: 'discovery_application',
        auto_crud: true,
        breadcrumb: 'Discovery Application',
        showMenu: true,
        check_permission: false
    }
]
